import AnalysisContentObjectModel from './AnalysisContentObjectModel';
import { AnalysisContentWidgetModel } from './AnalysisContentWidgetModel';

import { ITimePeriod } from './types/ITimePeriod';
import { IMeasure } from './types/IMeasure';
import { IStaticProperty } from './types/IStaticProperty';
import { IBoardDataObject } from './types/IBoardDataObject';

export class AnalysisContentModel {
  id: number;
  templateId: any;
  type: string;
  name: string;
  scenarios: any[];
  widgets: AnalysisContentWidgetModel[];
  objectDefinitions: any[];
  scenarioIds: any[];
  scenarioNodes: any[];
  objects: AnalysisContentObjectModel[];
  timePeriods: ITimePeriod[];
  contentNodes: any;
  classifications: any[];
  measures: IMeasure[];
  staticProperties: IStaticProperty[];
  suppressLocalCurrency: boolean;
  userContent: any;

  constructor(analysisContent: IBoardDataObject) {
    this.id = analysisContent.id;
    this.templateId = analysisContent.templateId;
    this.type = analysisContent.type;
    this.name = analysisContent.name;
    this.scenarios = analysisContent.scenarios;

    this.widgets = [];
    analysisContent.widgets.map((widget) => {
      const widgetObj = new AnalysisContentWidgetModel(widget);
      this.widgets.push(widgetObj);
    });

    this.objects = [];
    analysisContent.objects.map((object) => {
      const objectObj = new AnalysisContentObjectModel(object);
      this.objects.push(objectObj);
    });

    this.objectDefinitions = analysisContent.objectDefinitions;
    this.scenarioIds = analysisContent.scenarioIds;
    this.scenarioNodes = analysisContent.scenarioNodes;
    this.timePeriods = analysisContent.timePeriods;
    this.contentNodes = analysisContent.contentNodes;
    this.classifications = analysisContent.classifications;
    this.measures = analysisContent.measures;
    this.staticProperties = analysisContent.staticProperties;
    this.suppressLocalCurrency = analysisContent.suppressLocalCurrency;
    this.userContent = analysisContent.userContent;
  }

  loadWidgets = (templateWidgets) => {
    for (let i = 0; i < templateWidgets.length; i++) {
      this.addWidget(templateWidgets[i]);
    }
  };

  addWidget = (templateWidget) => {
    if (!this.findWidget(templateWidget.id)) {
      const w = new AnalysisContentWidgetModel();
      this.widgets.push(w.fromTemplate(templateWidget));
    }
  };

  findWidget = (templateWidgetId) => {
    return this.widgets.find(function (widget) {
      return widget.templateWidgetId === templateWidgetId;
    });
  };

  findObject = (objectId, parentObject) => {
    return this.findObjectByPath(this._objectPath(objectId, parentObject));
  };

  findObjectByPath = (path) => {
    return this.objects.find(function (item) {
      return item.objectPath === path;
    });
  };

  _objectPath = (objectId, parentObject) => {
    return (parentObject ? parentObject.objectPath + '-' : '') + objectId.toString();
  };

  loadWidgetNodes = () => {
    for (let i = 0; i < this.objects.length; i++) this.loadWidgetNodesForObject(this.objects[i]);
  };

  loadWidgetNodesForObject = (contentObject) => {
    for (let i = 0; i < this.widgets.length; i++) {
      let widget = this.widgets[i];
      widget.loadNodesForObject(contentObject);
    }
  };
}
